import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { addDataLayer } from 'lib/GoogleTagManager';
import { useDispatch } from "react-redux";
import { setDisplayMenu } from "../store/actions/layout";

const Wrapper = styled.button`
  font-weight: ${({theme}) => theme.typography.fontWeightBold};
  background-color: transparent;
  border: none;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 3rem;
  min-width: 3rem;
`;

const MenuSwitch = ({
  className, labelComponent, dataLayer,
}) => {

  const dispatch = useDispatch();

  const classes = ['MenuSwitch'];
  const buttonRef = React.useRef();

  function toggleModal() {
    if (dataLayer) {
      addDataLayer(dataLayer);
    }
    dispatch(setDisplayMenu(true));
  }

  if (className) classes.push(className);

  return (
    <Wrapper
      className={classes.join(' ')}
      onClick={toggleModal}
      dataLayer={dataLayer}
      ref={buttonRef}
    >
      {labelComponent}
    </Wrapper>
  );
};

MenuSwitch.displayName = 'MenuSwitch';

MenuSwitch.propTypes = {
  className: PropTypes.string,
  labelComponent: PropTypes.node.isRequired,
  dataLayer: PropTypes.shape({
    action: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  }),
};

MenuSwitch.defaultProps = {
  className: null,
  dataLayer: null,
};

export default MenuSwitch;
